__turbopack_context__.v({
  "container": "ProjectCard-module-scss-module__ZXKq7a__container",
  "content": "ProjectCard-module-scss-module__ZXKq7a__content",
  "description": "ProjectCard-module-scss-module__ZXKq7a__description",
  "image": "ProjectCard-module-scss-module__ZXKq7a__image",
  "imageWrapper": "ProjectCard-module-scss-module__ZXKq7a__imageWrapper",
  "imageWrapperDesktop": "ProjectCard-module-scss-module__ZXKq7a__imageWrapperDesktop",
  "imageWrapperMobile": "ProjectCard-module-scss-module__ZXKq7a__imageWrapperMobile",
  "link": "ProjectCard-module-scss-module__ZXKq7a__link",
  "linkText": "ProjectCard-module-scss-module__ZXKq7a__linkText",
  "linkTextMobile": "ProjectCard-module-scss-module__ZXKq7a__linkTextMobile",
  "root": "ProjectCard-module-scss-module__ZXKq7a__root",
});
